import { Component } from '@angular/core';
import { Subject } from 'rxjs';
import { FormMode } from '../../common/form-mode';
import { ContextualMenuEvent } from '../contextual-menu-event';
import { WorkflowDataInterface } from '../workflow-data.interface';

@Component({
    selector: 'app-workflow-trigger-no-data',
    imports: [],
    templateUrl: './workflow-trigger-folder-created.html',
    styleUrl: './workflow-trigger-folder-created.scss'
})
export class WorkflowTriggerFolderCreatedComponent implements WorkflowDataInterface {
    /**
     * Données affichées par le composant dynamique.
     */
    public data: string;

    /**
     * Mode d'affichage du formulaire.
     */
    mode: FormMode;

    /**
     * Source du menu contextuel.
     */
    contextualMenuSource: Subject<ContextualMenuEvent> = new Subject<ContextualMenuEvent>();

    /**
     * Constructeur.
     */
    constructor() {}

    /**
     * Indique si le formulaire est valide.
     */
    public isValid(): boolean {
        return true;
    }

    /**
     * Retourne une valeur indiquant si l'utilisateur a modifié des valeurs du formulaire.
     */
    public get dirty(): boolean {
        return false;
    }

    /**
     * Annulle les changements effectués par l'utilisateur.
     */
    public clearData() {}
}
